// Servicios
import Imagenologia from "../assets/Servicios/Recurso 1.webp";
import Urgencias from "../assets/Servicios/Recurso 2.webp";
import Laboratorio from "../assets/Servicios/Recurso 3.webp";
import Hospitalizacion from "../assets/Servicios/Recurso 4.webp";
import Intermedia from "../assets/Servicios/Recurso 5.webp";
import Traslados from "../assets/Servicios/Recurso 6.webp";
import Cirugia from "../assets/Servicios/Recurso 7.webp";
import Qx from "../assets/Servicios/Recurso 8.webp";
import Maternidad2 from "../assets/Servicios/Recurso 9.webp";
import Tamiz from "../assets/Servicios/Recurso 10.webp";
import Cuidados from "../assets/Servicios/Recurso 11.webp";
import ConsultaExterna from "../assets/Servicios/Recurso 12.webp";
import Esterilizacion from "../assets/Servicios/Recurso 13.webp";
import Farmacia from "../assets/Servicios/Recurso 14.webp";
import Endoscopia from "../assets/Servicios/Recurso 15.webp";
import Oftamica from "../assets/Servicios/Recurso 16.webp";
import Marcapasos from "../assets/Servicios/Recurso 17.webp";
import Mapeo from "../assets/Servicios/Recurso 18.webp";
import Holter from "../assets/Servicios/Recurso 19.webp";
import Shock from "../assets/Servicios/Recurso 20.webp";

// Informacion Especialistas Medicos
import archivoDePrueba from "../assets/Especialistas/Informacion_Especialista/PATRONESCOLOR.pdf";

// Servicios Informacion
export const dataServicios = [
  {
    id: "service-001",
    titulo: "Tomografía",
    subtitulo: "Técnica diagnóstica que combina rayos X y procesamiento digital para crear cortes transversales tridimensionales del cuerpo. Facilita la detección rápida de fracturas complejas, tumores y hemorragias internas.",
    image: Imagenologia,
    telefono: "311 214 0083 / Ext. 149",
    numero: "3112140083",
    tipo: "Estudios de imagen",
    pdf: archivoDePrueba
  },
  {
    id: "service-002",
    titulo: "Urgencias las 24 horas",
    subtitulo: "Área de atención inmediata disponible de forma permanente para la valoración y tratamiento de eventos médicos críticos o inesperados por parte de especialistas.",
    image: Urgencias,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Urgencias"
  },
  {
    id: "service-003",
    titulo: "Laboratorio las 24 horas",
    subtitulo: "Servicio continuo de análisis clínicos para el procesamiento de muestras biológicas a cualquier hora del día. Entrega resultados oportunos para respaldar diagnósticos precisos en emergencias y hospitalización.",
    image: Laboratorio,
    telefono: "(311) 214 0083 / Ext. 116",
    numero: "3112140083",
    tipo: "Laboratorio"
  },
  {
    id: "service-004",
    titulo: "Hospitalización",
    subtitulo: "Área equipada para brindar estancia médica, monitoreo constante y cuidados integrales a pacientes que requieren recuperación postoperatoria o tratamiento supervisado.",
    image: Hospitalizacion,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Hospitalización"
  },
  // {
  //   id: "service-005",
  //   titulo: "Terapia Intermedia",
  //   subtitulo: "Cuidado especializado para los pacientes en condiciones críticas.",
  //   image: Intermedia,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Especialistas"
  // },
  // {
  //   id: "service-006",
  //   titulo: "Traslados programados",
  //   subtitulo: "Modernas unidades equipadas para el traslados seguros dentro y fuera de la ciudad.",
  //   image: Traslados,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Atención"
  // },
  // {
  //   id: "service-007",
  //   titulo: "Cirugía HoLEP",
  //   subtitulo: "Equipo de vanguardia para el tratamiento de padecimientos de la próstata.",
  //   image: Cirugia,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Especialistas"
  // },
  // {
  //   id: "service-008",
  //   titulo: "Quirófanos",
  //   subtitulo: "Salas de quirófano con tecnología de punta para la realización de cirugías.",
  //   image: Qx,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Atención"
  // },
  // {
  //   id: "service-009",
  //   titulo: "Paquetes de maternidad",
  //   subtitulo: "Reciba a su bebé en un espacio totalmente seguro, con la mejor atención.",
  //   image: Maternidad2,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Maternidad"
  // },
  {
    id: "service-010",
    titulo: "Tamiz Neonatal",
    subtitulo: "Prueba preventiva obligatoria que se realiza mediante una pequeña punción en el talón del recién nacido. Permite identificar a tiempo enfermedades metabólicas graves para iniciar un tratamiento temprano.",
    image: Tamiz,
    telefono: "(311) 214 0083 / Ext. 116",
    numero: "3112140083",
    tipo: "Laboratorio"
  },
  // {
  //   id: "service-011",
  //   titulo: "Cuidados Intensivos Neonatales",
  //   subtitulo: "Cuidado especializado para los recién nacidos.",
  //   image: Cuidados,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Maternidad"
  // },
  // {
  //   id: "service-012",
  //   titulo: "Consulta externa",
  //   subtitulo: "Salas de quirófano con tecnología de punta para la realización de cirugías.",
  //   image: ConsultaExterna,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Atención"
  // },
  {
    id: "service-013",
    titulo: "Esterilización por plasma, vapor y gas",
    subtitulo: "Procesos avanzados de desinfección hospitalaria que garantizan la eliminación total de microorganismos en el instrumental médico según la delicadeza de su material.",
    image: Esterilizacion,
    telefono: "311 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Esterilización"
  },
  {
    id: "service-014",
    titulo: "Farmacia",
    subtitulo: "Servicio de abastecimiento intrahospitalario y venta al público con un catálogo amplio de medicamentos de patente y especialidad para dar continuidad a los tratamientos.",
    image: Farmacia,
    telefono: "311 214 0083 / Ext. 124",
    numero: "3112140083",
    tipo: "Farmacia"
  },
  {
    id: "service-015",
    titulo: "Sala de endoscopia",
    subtitulo: "Espacio equipado con cámaras flexibles para la exploración directa del tubo digestivo y vías respiratorias. Permite realizar diagnósticos visuales y procedimientos terapéuticos de mínima invasión.",
    image: Endoscopia,
    telefono: "(311) 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  // {
  //   id: "service-016",
  //   titulo: "Oftálmica",
  //   subtitulo: "Detección y tratamiento de padecimientos oculares por médicos especialista.",
  //   image: Oftamica,
  //   telefono: "311 211 9470 EXT. 195",
  //   numero: "3112119470",
  //   tipo: "Especialistas"
  // },
  {
    id: "service-017",
    titulo: "Marcapasos temporal",
    subtitulo: "Dispositivo de soporte vital transitorio que regula el ritmo cardíaco mediante impulsos eléctricos en situaciones de emergencia o previas a una cirugía definitiva.",
    image: Marcapasos,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Cardiología"
  },
  {
    id: "service-018",
    titulo: "Mapeo de la presión arterial",
    subtitulo: "Registro ambulatorio que mide la presión arterial de forma continua durante 24 horas. Ayuda a diagnosticar hipertensión con precisión durante la rutina diaria del paciente.",
    image: Mapeo,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Cardiología"
  },
  // {
  //   id: "service-019",
  //   titulo: "Holter",
  //   subtitulo: "Reciba a su bebé en un espacio totalmente seguro, con la mejor atención las 24 horas.",
  //   image: Holter,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Maternidad"
  // },
  {
    id: "service-020",
    titulo: "Área de shock",
    subtitulo: "Zona de atención prioritaria dentro de urgencias destinada a la reanimación inmediata e intervención de pacientes en estado crítico o con riesgo vital inminente.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Urgencias"
  },
  {
    id: "service-021",
    titulo: "Resonancia Magnética",
    subtitulo: "Estudio de imagenología de alta precisión que utiliza campos magnéticos para obtener vistas detalladas de tejidos blandos y órganos. Permite diagnosticar lesiones neurológicas, musculares y articulares sin emitir radiación.",
    image: Shock,
    telefono: "311 214 0083 / EXT. 149",
    numero: "3112140083",
    tipo: "Estudios de imagen"
  },
  {
    id: "service-022",
    titulo: "Rayos X",
    subtitulo: "Estudio de radiología convencional rápido y no invasivo diseñado para evaluar la estructura ósea y el área torácica. Es fundamental en la detección oportuna de fracturas, luxaciones y afecciones pulmonares básicas.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 149",
    numero: "3112140083",
    tipo: "Estudios de imagen"
  },
  {
    id: "service-023",
    titulo: "Ultrasonidos",
    subtitulo: "Estudio médico basado en ondas de sonido de alta frecuencia para visualizar órganos internos y monitorear el embarazo. Es un procedimiento completamente seguro, indoloro y libre de radiación.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 158",
    numero: "3112140083",
    tipo: "Estudios de imagen"
  },
  {
    id: "service-024",
    titulo: "Unidad de Cuidados Intensivos Neonatales",
    subtitulo: "Espacio altamente especializado equipado con incubadoras y tecnología médica avanzada para la atención crítica de recién nacidos prematuros o en estado delicado.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Hospitalización"
  },
  {
    id: "service-025",
    titulo: "Unidad de Terapia intermedia",
    subtitulo: "Área destinada a pacientes que requieren vigilancia continua y cuidados constantes, pero sin el grado de soporte vital invasivo que exige la terapia intensiva.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Hospitalización"
  },
  {
    id: "service-026",
    titulo: "Quirófanos",
    subtitulo: "Salas de operaciones diseñadas bajo estrictos estándares de esterilidad y equipamiento quirúrgico avanzado. Están preparadas para realizar intervenciones programadas y de urgencia con máxima seguridad.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  {
    id: "service-027",
    titulo: "Cirugía con láser HoLEP, Argón, Armónico y Radiofrecuencia",
    subtitulo: "Procedimientos quirúrgicos de última generación que garantizan cortes e incisiones de alta precisión. Reducen sensiblemente el sangrado, el dolor y el tiempo de recuperación del paciente.",
    image: Shock,
    telefono: "(311) 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  {
    id: "service-028",
    titulo: "Paquetes de cirugías",
    subtitulo: "Planes médicos integrales que agrupan honorarios, quirófano, anestesia y estancia hospitalaria bajo un costo cerrado. Brindan certidumbre financiera y transparencia antes del procedimiento.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 162",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  {
    id: "service-029",
    titulo: "Electrocardiograma",
    subtitulo: "Prueba rápida que registra la actividad eléctrica del corazón en una gráfica. Es clave para detectar arritmias, evaluar la función cardíaca e identificar signos de infarto de forma inmediata.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Cardiología"
  },
  {
    id: "service-031",
    titulo: "Ambulancias",
    subtitulo: "Unidades de traslado terrestre dotadas de equipo de soporte vital y personal capacitado para la atención prehospitalaria y el transporte seguro de pacientes.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 162",
    numero: "3112140083",
    tipo: "Ambulancia"
  },
  {
    id: "service-032",
    titulo: "Membresía de salud",
    subtitulo: "Programa de afiliación que otorga tarifas preferenciales, descuentos exclusivos y beneficios preventivos en consultas y estudios para el titular y sus beneficiarios.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 192",
    numero: "3112140083",
    tipo: "Membresía y seguros médicos"
  },
  {
    id: "service-033",
    titulo: "Seguros médicos",
    subtitulo: "Módulo de atención especializado para la gestión, trámite de coberturas y pase directo con las principales compañías aseguradoras del país.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 126",
    numero: "3112140083",
    tipo: "Membresía y seguros médicos"
  },
  {
    id: "service-034",
    titulo: "Servicios oftalmológicos",
    subtitulo: "Atención médica y quirúrgica orientada al diagnóstico, prevención y tratamiento integral de afecciones en la vista y la estructura ocular.",
    image: Shock,
    telefono: "311 214 0083 / Ext. 195",
    numero: "3112140083",
    tipo: "Oftalmología"
  },
];

// Servicios Categorias
export const categoriaServicios = [
  "Estudios de imagen",
  "Laboratorio",
  "Hospitalización",
  "Servicios quirúrgicos",
  "Cardiología",
  "Urgencias",
  "Ambulancia",
  "Esterilización",
  "Farmacia",
  "Membresía y seguros médicos",
  "Oftalmología"
];
